import React from 'react';
import * as Ons from 'react-onsenui';

class Season extends React.Component {

    render() {

        return (

            <Ons.ListItem modifier={this.props.modifier} tappable={true} onClick={() => this.props.onClick( this.props.season )}>
                <div className="center">{this.props.season.leagueName} &raquo; {this.props.season.longname}</div>
                <div className="right"><Ons.Icon icon='fa-chevron-right' /></div>
            </Ons.ListItem>

        );

    }

}

export default Season;